export const pipMessages = {
  'zh-CN': {
    chooseMode: '选择小组件打开方式', modeUnavailable: '当前浏览器环境不可用',
    modes: {
      pip: { name: '画中画窗口', hint: '置顶显示，占用浏览器画中画。' },
      popup: { name: '独立窗口', hint: '不占用画中画，不会自动置顶。' },
    },
    open: '打开小组件', opening: '正在打开…', dismiss: '收起', retry: '重新打开', retryPopup: '打开普通窗口',
    copyLink: '复制页面链接', officialSite: '打开正式站点', newTab: '在新标签页打开',
    help: '查看帮助', diagnostics: '查看诊断信息', copyDiagnostic: '复制诊断信息',
    copied: '已复制', copyFailed: '未能自动复制，请选中下方文字手动复制。', manualCopy: '可手动复制的内容',
    selectWindow: '选择游戏窗口', retryOcr: '重试识别',
    dashboard: '仍可在控制面板查看统计。',
    captureFirst: '请先连接游戏窗口并完成画面识别，才能在控制面板查看实时统计。',
    helpText: '请回到当前页面并点击“重新打开”。若仍然失败，可更新桌面版 Edge / Chrome，或检查浏览器和组织的功能限制。',
    popupBadge: '普通窗口',
    popupHint: '无法置顶，将打开普通窗口。直播仍可捕获。',
    popupHelp: '若弹窗被拦截，请允许本站弹出窗口后再试。需要盖在游戏上方时，请改用官方桌面 Edge 或 Chrome。',
    refreshHint: '若重试后仍无法加载，请先结束当前记录，再刷新页面。',
    localDiagnostic: '仅包含浏览器、能力检测和错误分类，保留在本次页面运行中，不会自动上传。',
    'insecure-context': { title: '当前打开方式无法使用小组件', hint: '页面不在安全上下文中，请通过 HTTPS 地址访问枫记。' },
    embedded: { title: '请在独立标签页打开枫记', hint: '当前页面处于内嵌框架中，请在独立浏览器标签页中打开，再使用小组件。' },
    unsupported: { title: '当前浏览器环境无法打开小组件', hint: '请复制链接，使用电脑上的最新版 Microsoft Edge 或 Google Chrome 打开。' },
    'not-connected': { title: '请先连接游戏窗口', hint: '选择正在运行的游戏窗口，完成画面识别后，再点击“打开小组件”。' },
    'ocr-preparing': { title: '正在准备画面识别', hint: '请等待画面连接和识别准备完成，再点击“打开小组件”。' },
    'ocr-error': { title: '画面识别尚未准备好', hint: '识别准备未能完成，请重试识别后再打开小组件。' },
    ending: { title: '正在完成记录保存', hint: '记录保存完成后即可打开小组件。' },
    reloading: { title: '正在准备刷新页面', hint: '页面刷新完成后即可打开小组件。' },
    'request-denied': {
      title: '浏览器未允许本次打开',
      hint: '请回到当前页面后点击“重新打开”。若使用的是独立窗口，请允许本站弹出窗口。',
      fallbackTitle: '无法置顶小组件',
      fallbackHint: '当前浏览器不能把小组件盖在游戏上方。点击下方按钮即可打开普通窗口，直播软件仍能捕获。',
    },
    'resource-load': { title: '小组件内容未能加载', hint: '请检查网络连接，然后重试。' },
    unknown: { title: '小组件暂时无法打开', hint: '可以重新尝试；若仍然失败，请复制诊断信息反馈。' },
  },
  en: {
    chooseMode: 'Choose how to open the widget', modeUnavailable: 'Unavailable in this browser environment',
    modes: {
      pip: { name: 'Picture-in-picture window', hint: 'Stays on top and uses browser picture-in-picture.' },
      popup: { name: 'Separate window', hint: 'Keeps picture-in-picture free; does not stay on top.' },
    },
    open: 'Open widget', opening: 'Opening…', dismiss: 'Dismiss', retry: 'Try opening again', retryPopup: 'Open regular window',
    copyLink: 'Copy page link', officialSite: 'Open official site', newTab: 'Open in new tab',
    help: 'View help', diagnostics: 'View diagnostics', copyDiagnostic: 'Copy diagnostics',
    copied: 'Copied', copyFailed: 'Could not copy automatically. Select the text below and copy it manually.', manualCopy: 'Text to copy manually',
    selectWindow: 'Choose game window', retryOcr: 'Retry recognition',
    dashboard: 'You can still view statistics on the dashboard.',
    captureFirst: 'Connect the game window and finish recognition setup to view live statistics on the dashboard.',
    helpText: 'Return to this page and click “Try opening again”. If it still fails, update desktop Edge / Chrome or check browser and organization restrictions.',
    popupBadge: 'Regular window',
    popupHint: 'Opens as a regular window; it cannot stay above the game.',
    popupHelp: 'If the window is blocked, allow pop-ups for this site and try again. Use official desktop Edge or Chrome when you need it above the game.',
    refreshHint: 'If retrying does not help, finish the current recording before refreshing this page.',
    localDiagnostic: 'Only browser information, capability checks and error categories are included. Kept for this page session and never uploaded automatically.',
    'insecure-context': { title: 'This page cannot open the widget', hint: 'The page is not in a secure context. Access Maple Log through its HTTPS address.' },
    embedded: { title: 'Open Maple Log in its own tab', hint: 'This page is inside an embedded frame. Open it in a separate browser tab to use the widget.' },
    unsupported: { title: 'The widget is unavailable in this browser', hint: 'Copy the link and open it in the latest desktop Microsoft Edge or Google Chrome.' },
    'not-connected': { title: 'Connect the game window first', hint: 'Choose the running game window and finish recognition setup, then click “Open widget”.' },
    'ocr-preparing': { title: 'Preparing screen recognition', hint: 'Wait for the game connection and recognition setup to finish, then click “Open widget”.' },
    'ocr-error': { title: 'Screen recognition is not ready', hint: 'Setup could not finish. Retry recognition before opening the widget.' },
    ending: { title: 'Finishing the recording', hint: 'You can open the widget after the recording is saved.' },
    reloading: { title: 'Preparing to refresh', hint: 'You can open the widget after the page refreshes.' },
    'request-denied': {
      title: 'The browser did not allow this attempt',
      hint: 'Return to this page and click “Try opening again”. If this opens a standalone window, allow pop-ups for this site.',
      fallbackTitle: 'Always-on-top is unavailable',
      fallbackHint: 'This browser cannot keep the widget above the game. Click below to open a regular window. Streaming tools can still capture it.',
    },
    'resource-load': { title: 'Widget content could not load', hint: 'Check your internet connection, then try again.' },
    unknown: { title: 'The widget could not open', hint: 'Try again. If it still fails, copy the diagnostics to include with your feedback.' },
  },
}
